export default "__VITE_ASSET__07123b24__"